import { ComponentProps } from 'react'

import { Colors, Tag } from '@factorialco/deprecated-design-system'
import { keyBy } from 'lodash'

const COLORS_BY_SCALE_ID: Record<number, Colors[]> = {
  1: ['radicalRed1000', 'radicalRed400', 'viridian200', 'viridian400', 'viridian1000'], // 1-5
  2: ['radicalRed1000', 'viridian200', 'viridian400', 'viridian1000'], // 1-4
  3: [
    'radicalRed1000',
    'radicalRed1000',
    'radicalRed400',
    'radicalRed400',
    'viridian200',
    'viridian200',
    'viridian400',
    'viridian400',
    'viridian1000',
    'viridian1000',
  ], // 1-10
}

const TAG_PROPS_BY_SCORE: Record<string, ComponentProps<typeof Tag>> = {
  '1/5': { type: 'radical', solid: true },
  '2/5': { type: 'radical', solid: false },
  '3/5': { type: 'viridian', solid: false },
  '4/5': { type: 'viridian', solid: true },
  '5/5': { type: 'viridian', solid: true },

  '1/4': { type: 'radical', solid: true },
  '2/4': { type: 'viridian', solid: false },
  '3/4': { type: 'viridian', solid: true },
  '4/4': { type: 'viridian', solid: true },

  '1/10': { type: 'radical', solid: true },
  '2/10': { type: 'radical', solid: true },
  '3/10': { type: 'radical', solid: false },
  '4/10': { type: 'radical', solid: false },
  '5/10': { type: 'viridian', solid: false },
  '6/10': { type: 'viridian', solid: false },
  '7/10': { type: 'viridian', solid: false },
  '8/10': { type: 'viridian', solid: false },
  '9/10': { type: 'viridian', solid: true },
  '10/10': { type: 'viridian', solid: true },
}

const COLORS_BY_MAX_SCORE: Record<number, Colors[]> = keyBy(
  Object.values(COLORS_BY_SCALE_ID),
  'length'
)

export const colorsForEmployeeScoreScaleId = (scaleId: number): Colors[] => {
  const colors = COLORS_BY_SCALE_ID[scaleId]

  if (!colors) return []

  return colors
}

export const colorForEmployeeScore = (score: number, maxScore: number): Colors => {
  const colors = COLORS_BY_MAX_SCORE[maxScore]
  const color = colors?.[Math.round(score) - 1]

  if (!color) return 'grey400'

  return color
}

// In the end, the "type" and "solid" props are used to set the color of the tag.
// So to avoid messing up with the score tags again, we preferred to define the props here
// alongside the other colors to have a single source of truth and under our control.
export const tagPropsForEmployeeScore = (
  score: number,
  maxScore: number
): ComponentProps<typeof Tag> => {
  const key = `${Math.round(score)}/${maxScore}`
  const props = TAG_PROPS_BY_SCORE[key]

  if (!props) return {}

  return props
}
